function ContentProgramming(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">편성</h4>
                <h5 className="recruit_titleline_title">편성</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    편성팀은 SBS의 주간 단위 TV 편성 및 운행, 프로그램 제작비의 관리를 담당하는 부서입니다. 프로그램의 편성은<br />
                    SBS 채널의 경쟁력은 물론 지상파 방송사로서 가져야 하는 공익성, 장기적 관점에서 채널의 이미지, 수익성까지<br />
                    다양한 측면을 고려해야 합니다. 편성팀 내 주간 편성 파트의 담당자는 이를 위해서 다양한 측면에서 콘텐츠의<br />
                    장단점을 파악하고 판단할 수 있는 통찰력, 시청률 등 각종 시청자 데이터를 분석하여 개별 콘텐츠에 맞는 최적의<br />
                    시간대를 찾아내는 데이터 활용 능력, 현 시대의 트렌드에 대한 감각, 채널 전체의 입장에서 최적의 선택을 하고<br />
                    이러한 선택을 기반으로 개별 프로그램 제작진과 의견을 조율하고 설득할 수 있는 커뮤니케이션 능력이 요구됩니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    콘텐츠 기획팀에서 기본 편성표를 통해 편성 틀을 마련하면 편성팀은 이를 바탕으로 각 프로그램의 경쟁력을<br />
                    극대화할 수 있는 방송 운행 시간을 미시적으로 조정하는 등 최종 송출되는 순간까지 모든 요소들을 조율하고<br />
                    운영합니다. 그리고 정규 편성과 별도로 스포츠 중계방송(올림픽, 월드컵 등), 국가 주요행사(선거, 토론회 등),<br />
                    다양한 특집 프로그램(명절, 연말 시상식 등)을 위한 최적의 시간대를 찾아내어 편성하는 일을 수행합니다.<br />
                    또한 각 프로그램의 제작비 규모를 협의하고 확정하며 실제 프로그램 제작시 적절하게 집행되었는지 관리하는 업무도<br />
                    수행합니다.
                </p>
                <em className="recruit_bold_text">주간 편성</em>
                <p className="recruit_subinfo_text">
                    주간 단위 편성표를 작성합니다. 기존 정규 프로그램과 수시로 발생하는 특집 프로그램을 시청자 관련 데이터를 기반으로 하여 프로그램 경쟁력과 채널 이미지, 수익성 등을 종합적으로 고려하고 판단하여 이를 프로그램 제작진들과 공유하고 의견을 조율하여 최종 결정을 내립니다.
                </p>
                <em className="recruit_bold_text">TV 운행</em>
                <p className="recruit_subinfo_text">
                    프로그램 송출의 마지막 단계인 TV 주조정실에서 각 프로그램이 문제없이 송출될 수 있도록 사전에<br />
                    협의된 제작시간 및 편성, 운행 시간을 관리하고 조정합니다.<br />
                </p>
                <em className="recruit_bold_text">제작비 예산</em>
                <p className="recruit_subinfo_text">
                    개별 프로그램의 제작비를 제작팀과 협의하고 예산을 배정하며, 매 분기 실적 검토를 통해 제작비를 관리합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    최근 OTT 등에서 콘텐츠를 비실시간으로 시청하는 시청자의 수가 가파르게 증가하고 있지만 실시간 TV 방송을<br />
                    시청하는 인구도 여전히 많고, 실시간 TV 방송의 경쟁력이 SBS의 수익성에 미치는 영향 또한 매우 큽니다.<br />
                    이런 환경에서 편성팀은 SBS의 주요 콘텐츠와 국민 관심이 집중되는 특집 프로그램들을 최적의 조합으로<br />
                    편성할 수 있도록 판단하고 조율합니다. 이 과정에서 콘텐츠를 다양한 시각에서 판단할 수 있는 능력을<br />
                    향상시킬 수 있으며, 개별 프로그램이 아닌 회사와 채널 전체를 거시적 시각에서 바라보는 안목 또한<br />
                    갖출 수 있습니다. 이를 바탕으로 향후 콘텐츠 기획이나 콘텐츠를 기반으로 한 다양한 부서에서<br />
                    업무를 수행할 수 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 콘텐츠전략본부 편성팀에서 주간편성업무를 맡고있는 편성PD 권하영입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">편성PD가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    경영직군으로 입사해 인사팀에서 근무하다가 편성 일에 매력을 느껴서 편성PD로 부서를 이동하여 근무하고 있습니다. &#39;사람&#39;과 &#39;콘텐츠&#39;가<br />
                    핵심인 우리 회사에서 이 둘에 관련한 업무를 경험할 수 있어 행운이라고 생각합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    타사와 동시 경쟁하는 상황에서, 특히 편성 전략이 중요하게 작용하는 올림픽 중계나 선거개표방송 같은 빅이벤트에서 SBS가 좋은 성적을<br />
                    거뒀을 때 큰 보람을 느낍니다.<br /><br />
                    편성PD는 매일 끊임없이 발생하는 크고 작은 편성 이슈에 대해 짧은 시간 내에 최선의 방안을 도출해야 하는데 경험이 쌓이면 쌓일수록 더<br />
                    빠르고 정확하게 판단을 내릴 수 있습니다.
                    매일 다양한 상황을 겪으면서 본인이 성장하고 있다는 느낌을 가지고 업무에 임할 수 있다는 것도<br />
                    주간편성의 매력 중 하나입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    편성PD는 방송사에 근무하는 사람 중 가장 다양한 콘텐츠를 가까이하면서 콘텐츠에 대한 본인의 인사이트를 시청자 데이터와 매치하여 최적의 편성 시간을 찾아내는 매력적인 직업입니다.<br /><br />
                    또한 프로그램 하나하나를 들여다보며 고민하는 과정에서 제작 현장을 파악하고, 예산/광고/정책 등 경영 파트와 밀접하게 연결되어 있어서<br />
                    회사 안에서 제작과 경영의 가교역할을 하고 있습니다. 편성PD는 연차나 나이에 상관없이 콘텐츠에 대한 의견을 자유롭게 교환하는 분위기에서 근무하기 때문에
                    신입사원도 자기 몫을 해내며 빠르게 성장할 수 있으니 많은 지원 바랍니다.
                </p>
            </div>
        </div>);
}

export default ContentProgramming;

